import { useContext, useEffect } from "react"
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import * as ApiService from '../../services/ApiService'

export const useUserProfile = () => {
    const { userState } = useContext(ApplicationContext);
    const { providerState } = useContext(ProviderContext);

    const fetchSelectedUserMeasurement = async (userID: string) => {
        return await ApiService.fetchUserMeasurement(userState.authenticatedUser, userID, providerState.providerId).then((res) => {
            return res
        }).catch(error => {
            alert('Something went wrong. Please try again.')
            return error
        })
    }

    const fetchUserProviders = async (userID: string) => {
        return await ApiService.fetchUserProviders(userState.authenticatedUser, userID, providerState.providerId).then((res) => {
            return res
        }).catch(error => {
            alert('Something went wrong. Please try again.')
            return error
        })
    }

    return {
        fetchSelectedUserMeasurement,
        fetchUserProviders
    }
}
